// eslint-disable-next-line no-unused-vars
import React from 'react';
import { oneOfType, object, string, node, bool } from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

const StyledFilters = styled.div`
  width: 100%;
  min-width: 250px;
  max-width: 260px;
  margin-top: 9px;
  margin-right: 30px;
  position: relative;
  height: 100%;

  .overlay {
    cursor: progress;
  }

  .filterGroup {
    display: flex;
    flex-direction: column;
    margin-bottom: 1em;
    position: relative;
    max-height: 320px;
    overflow: hidden;
    transition: max-height 0.25s ease;

    &.closed {
      max-height: 37px;
    }

    &.open {
      .header .close {
        transform: rotate(180deg);
        transition: all 0.2s ease;
      }
      max-height: 320px;
    }

    .header {
      display: flex;
      color: ${ props => props.theme.colors.darkGray };
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid ${ props => props.theme.products.colors.border };
      padding-bottom: 5px;
      margin-bottom: 5px;
      position: relative;

      &:after {
        display: block;
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        max-width: 70px;
        background-color: ${ props => props.theme.colors.default };
      }

      .close {
        &:hover,
        &:active {
          background-color: rgba(0, 0, 0, 0.015);
          border-radius: 5px;
          outline: 0;
          border: 0;
          box-shadow: none;
        }
        padding: 10px 5px;
        color: inherit;
        transform: rotate(0);
        transition: all 0.2s ease;
        border: 0 !important;
      }
    }

    .filterTitle {
      font-size: 1.15em;
      color: inherit;
    }

    .filterItem {
      width: 100%;
      height: auto;
      padding: 0;
      display: flex;
      justify-content: space-between;
      outline: 0;
      box-shadow: none;
      align-items: center;
      font-size: 0.875rem;
      color: ${ props => props.theme.colors.darkGray };
      line-height: 1rem;
      text-align: left;

      .count {
        color: ${ props => props.theme.colors.lightGray };
      }

      > div {
        margin-right: 5px;
        margin-top: 5px;
      }
    }

    .options {
      max-height: ${ props => props.open ? 'none' : '240px' };
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .viewMore {
      width: 100%;
      min-height: 0;
      height: 25px;
      background-color: ${ props => props.theme.colors.white };
      color: ${ props => props.theme.products.colors.inStock };
      font-size: 0.875em;
      padding: 0;
      margin-top: 5px;
    }
  }

  @media screen and (max-width: 767px) {
    display: ${ props => props.mobileFiltersOpen ? 'block' : 'none' };
    position: fixed;
    min-width: 100%;
    background: #fff;
    inset: 0;
    z-index: 9001;
    overflow: scroll;
    padding: 0 20px 20px 20px;
    margin-top: 0;
  }
`;

const Filters = ({ children, error, activeFilters, mobileFiltersOpen }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <StyledFilters
      theme={ theme }
      mobileFiltersOpen={ mobileFiltersOpen }
      withTitle={ !!activeFilters?.category }
    >
      {
        error
          ? <p>{ t('filters.error') } { error }</p>
          : children
      }
    </StyledFilters>
  );
};

Filters.propTypes = {
  children: node,
  activeFilters: object,
  mobileFiltersOpen: bool,
  error: oneOfType([string, object]),
};

export default Filters;
